/**
 * `true` while the viewport is in the app's mobile-shell range (<= 899px —
 * the same breakpoint at which the shell swaps the sidebar for the bottom
 * nav, see `styles/v2/components.css`). Used ONLY where the DOM itself must
 * differ between mobile and desktop (e.g. a card list instead of a data grid,
 * a shorter chart); everything else in the AI module is plain CSS media
 * queries on the `ai-*` classes.
 */
import { useSyncExternalStore } from 'react';

export const MOBILE_SHELL_QUERY = '(max-width: 899px)';

function subscribe(onChange: () => void): () => void {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return () => {};
  const list = window.matchMedia(MOBILE_SHELL_QUERY);
  list.addEventListener('change', onChange);
  return () => list.removeEventListener('change', onChange);
}

function getSnapshot(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
  return window.matchMedia(MOBILE_SHELL_QUERY).matches;
}

export function useMobileShell(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, () => false);
}
